var Backbone = require('backbone');
var _ = require('underscore');
var svg4everybody = require('svg4everybody');
var objectFitImages = require('object-fit-images/dist/ofi.common-js.js');
var stickyfill = require('stickyfill')();
require('lie/polyfill');
require('lazysizes');

var Settings = require('./Settings');
var Utils = require('front/utils/Utils.js');
var CheckDevice = require('front/utils/CheckDevice/CheckDevice.js');
var Router = require('./Router');

require('front/components/Footer/Footer');
require('front/components/GlobalBanner/GlobalBanner');
require('front/components/CastingButton/CastingButton');
var Content = require('front/components/Content/Content');
var Nav = require('front/components/Nav/Nav');
var Footer = require('front/components/Footer/Footer');
var PopupSections = require('front/components/PopupSections/PopupSections');

require('reset.css');
require('front/fonts.less');
require('front/utils.less');
require('front/style.less');

// Поддержка css свойства object-fit для IE и старых браузеров.
objectFitImages();

// Поддержка svg sprites в IE.
svg4everybody();

// Поддержка position sticky в IE.
app.stickyfill = stickyfill;
app.stickyfill.add($('.Content-topNav')[0]);

app.configure = Settings.configure;
app.configure();

app.cache = {};

window.app.vent = _.extend({}, Backbone.Events);

window.app.utils = Utils;

CheckDevice.initialize();

window.app.state = {};

window.app.els = {
    $window: $(window),
    $html: $('html'),
    $body: $('body'),
    $htmlBody: $('html,body'),
    $content: $('.Content'),
    $contentBody: $('.Content-body'),
    $contentFooter: $('.Content-footer'),
    $contentTopAd: $('.Content-topAd'),
    $contentTopNav: $('.Content-topNav')
};

app.views = {};
app.views.popupSections = new PopupSections();
app.views.nav = new Nav();
app.views.footer = new Footer();
app.views.content = new Content();

app.router = new Router();

app.router.start();

// Send ga events
$('.u-gaSend').click(function (e) {
    ga('send', {
            hitType: 'event',
            eventCategory: 'Outbound Link',
            eventAction: 'click',
            eventLabel: e.target.href,
            transport: 'beacon'
        }
    );
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/App.js
// module id = 164
// module chunks = 0